enum AiImageCategory {
    CUSTOM = 'custom',
    ILLUSTRATION = 'illustration',
    PHOTO = 'photo',
    THREE_DIMENSIONAL = '3d',
    ART_STYLE = 'art_style',
}

export default AiImageCategory;
